export const eventTypeLabels = { WORKSHOP: 'Workshop', WEBINAR: 'Webinar', HACKATHON: 'Hackathon', COURSE: 'Course' };
export const eventTypeColors = { WORKSHOP: 'primary', WEBINAR: 'secondary', HACKATHON: 'success', COURSE: 'info' };
export const getEventTypeLabel = (type) => eventTypeLabels[type] || type;
export const getEventTypeColor = (type) => eventTypeColors[type] || 'default';
